import { Globe, Mail, Users } from "lucide-react";

import "./Footer.css";

export function Footer(): JSX.Element {
  const year = new Date().getFullYear();

  return (
    <footer className="footer dashboard-footer" role="contentinfo">
      <div className="container footer__inner">
        {/* Brand Column */}
        <div className="footer__brand-col">
          <div className="footer__brand">
            <img
              src="/images/logo.png"
              alt="Soft9Tech"
              className="footer__logo-img"
            />
            <span className="footer__name">Soft9Tech Admin</span>
          </div>

          <p className="footer__copyright">© {year} Soft9Tech Admin</p>
        </div>

        {/* Connect Column */}
        <div className="footer__col">
          <h4 className="footer__col-title">Connect With Us</h4>
          <div className="footer__social">
            <a
              href="https://soft9tech.com"
              target="_blank"
              rel="noopener noreferrer"
              className="footer__social-btn"
              aria-label="Website"
            >
              <Globe size={18} />
            </a>
            <a
              href="mailto:contact@soft9tech.com"
              className="footer__social-btn"
              aria-label="Email"
            >
              <Mail size={18} />
            </a>
            <a
              href="https://soft9tech.com/community"
              target="_blank"
              rel="noopener noreferrer"
              className="footer__social-btn"
              aria-label="Community"
            >
              <Users size={18} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
